module.exports = __webpack_public_path__ + "img/EconomyTechBackgroundC01_ua.e2d2fa06.webp";